/* shop/components/OrderPersonal.svelte generated by Svelte v3.59.2 */
import {
	SvelteComponentDev,
	add_location,
	append_dev,
	attr_dev,
	component_subscribe,
	detach_dev,
	dispatch_dev,
	element,
	init,
	insert_dev,
	listen_dev,
	noop,
	prop_dev,
	run_all,
	safe_not_equal,
	space,
	validate_slots,
	validate_store
} from "svelte/internal";

import orderStore from "./../orderStore";
const file = "shop/components/OrderPersonal.svelte";

function create_fragment(ctx) {
	let p0;
	let label0;
	let t1;
	let input0;
	let input0_value_value;
	let t2;
	let p1;
	let label1;
	let t4;
	let input1;
	let input1_value_value;
	let t5;
	let p2;
	let label2;
	let t7;
	let input2;
	let input2_value_value;
	let t8;
	let p3;
	let label3;
	let t10;
	let input3;
	let input3_value_value;
	let t11;
	let p4;
	let label4;
	let t13;
	let input4;
	let input4_value_value;
	let t14;
	let p5;
	let label5;
	let t16;
	let input5;
	let input5_value_value;
	let t17;
	let p6;
	let label6;
	let t19;
	let textarea;
	let textarea_value_value;
	let mounted;
	let dispose;

	const block = {
		c: function create() {
			p0 = element("p");
			label0 = element("label");
			label0.textContent = "Jméno a příjmení";
			t1 = space();
			input0 = element("input");
			t2 = space();
			p1 = element("p");
			label1 = element("label");
			label1.textContent = "Email";
			t4 = space();
			input1 = element("input");
			t5 = space();
			p2 = element("p");
			label2 = element("label");
			label2.textContent = "Telefon";
			t7 = space();
			input2 = element("input");
			t8 = space();
			p3 = element("p");
			label3 = element("label");
			label3.textContent = "Ulice";
			t10 = space();
			input3 = element("input");
			t11 = space();
			p4 = element("p");
			label4 = element("label");
			label4.textContent = "Město";
			t13 = space();
			input4 = element("input");
			t14 = space();
			p5 = element("p");
			label5 = element("label");
			label5.textContent = "PSČ";
			t16 = space();
			input5 = element("input");
			t17 = space();
			p6 = element("p");
			label6 = element("label");
			label6.textContent = "Poznámka";
			t19 = space();
			textarea = element("textarea");
			attr_dev(label0, "for", "name_and_surname");
			add_location(label0, file, 22, 4, 514);
			attr_dev(input0, "type", "text");
			input0.required = true;
			attr_dev(input0, "id", "name_and_surname");

			input0.value = input0_value_value = /*$orderStore*/ ctx[0].name_and_surname
			? /*$orderStore*/ ctx[0].name_and_surname
			: "";

			add_location(input0, file, 23, 4, 573);
			add_location(p0, file, 21, 0, 506);
			attr_dev(label1, "for", "email");
			add_location(label1, file, 32, 4, 823);
			attr_dev(input1, "type", "email");
			input1.required = true;
			attr_dev(input1, "id", "email");

			input1.value = input1_value_value = /*$orderStore*/ ctx[0].email
			? /*$orderStore*/ ctx[0].email
			: "";

			add_location(input1, file, 33, 4, 860);
			add_location(p1, file, 31, 0, 815);
			attr_dev(label2, "for", "phone");
			add_location(label2, file, 42, 4, 1067);
			attr_dev(input2, "type", "text");
			input2.required = true;
			attr_dev(input2, "id", "phone");

			input2.value = input2_value_value = /*$orderStore*/ ctx[0].phone
			? /*$orderStore*/ ctx[0].phone
			: "";

			add_location(input2, file, 43, 4, 1106);
			add_location(p2, file, 41, 0, 1059);
			attr_dev(label3, "for", "address_street");
			add_location(label3, file, 52, 4, 1312);
			attr_dev(input3, "type", "text");
			input3.required = true;
			attr_dev(input3, "id", "address_street");

			input3.value = input3_value_value = /*$orderStore*/ ctx[0].address_stree
			? /*$orderStore*/ ctx[0].address_stree
			: "";

			add_location(input3, file, 53, 4, 1358);
			add_location(p3, file, 51, 0, 1304);
			attr_dev(label4, "for", "address_city");
			add_location(label4, file, 62, 4, 1598);
			attr_dev(input4, "type", "text");
			input4.required = true;
			attr_dev(input4, "id", "address_city");

			input4.value = input4_value_value = /*$orderStore*/ ctx[0].address_city
			? /*$orderStore*/ ctx[0].address_city
			: "";

			add_location(input4, file, 63, 4, 1642);
			add_location(p4, file, 61, 0, 1590);
			attr_dev(label5, "for", "address_zip");
			add_location(label5, file, 72, 4, 1876);
			attr_dev(input5, "type", "text");
			input5.required = true;
			attr_dev(input5, "id", "address_zip");

			input5.value = input5_value_value = /*$orderStore*/ ctx[0].address_zip
			? /*$orderStore*/ ctx[0].address_zip
			: "";

			add_location(input5, file, 73, 4, 1917);
			add_location(p5, file, 71, 0, 1868);
			attr_dev(label6, "for", "order_description");
			add_location(label6, file, 82, 4, 2147);
			attr_dev(textarea, "id", "order_description");

			textarea.value = textarea_value_value = /*$orderStore*/ ctx[0].order_description
			? /*$orderStore*/ ctx[0].order_description
			: '';

			add_location(textarea, file, 83, 4, 2199);
			add_location(p6, file, 81, 0, 2139);
		},
		l: function claim(nodes) {
			throw new Error("options.hydrate only works if the component was compiled with the `hydratable: true` option");
		},
		m: function mount(target, anchor) {
			insert_dev(target, p0, anchor);
			append_dev(p0, label0);
			append_dev(p0, t1);
			append_dev(p0, input0);
			insert_dev(target, t2, anchor);
			insert_dev(target, p1, anchor);
			append_dev(p1, label1);
			append_dev(p1, t4);
			append_dev(p1, input1);
			insert_dev(target, t5, anchor);
			insert_dev(target, p2, anchor);
			append_dev(p2, label2);
			append_dev(p2, t7);
			append_dev(p2, input2);
			insert_dev(target, t8, anchor);
			insert_dev(target, p3, anchor);
			append_dev(p3, label3);
			append_dev(p3, t10);
			append_dev(p3, input3);
			insert_dev(target, t11, anchor);
			insert_dev(target, p4, anchor);
			append_dev(p4, label4);
			append_dev(p4, t13);
			append_dev(p4, input4);
			insert_dev(target, t14, anchor);
			insert_dev(target, p5, anchor);
			append_dev(p5, label5);
			append_dev(p5, t16);
			append_dev(p5, input5);
			insert_dev(target, t17, anchor);
			insert_dev(target, p6, anchor);
			append_dev(p6, label6);
			append_dev(p6, t19);
			append_dev(p6, textarea);

			if (!mounted) {
				dispose = [
					listen_dev(input0, "blur", /*blur_handler*/ ctx[2], false, false, false, false),
					listen_dev(input1, "blur", /*blur_handler_1*/ ctx[3], false, false, false, false),
					listen_dev(input2, "blur", /*blur_handler_2*/ ctx[4], false, false, false, false),
					listen_dev(input3, "blur", /*blur_handler_3*/ ctx[5], false, false, false, false),
					listen_dev(input4, "blur", /*blur_handler_4*/ ctx[6], false, false, false, false),
					listen_dev(input5, "blur", /*blur_handler_5*/ ctx[7], false, false, false, false),
					listen_dev(textarea, "blur", /*blur_handler_6*/ ctx[8], false, false, false, false)
				];

				mounted = true;
			}
		},
		p: function update(ctx, [dirty]) {
			if (dirty & /*$orderStore*/ 1 && input0_value_value !== (input0_value_value = /*$orderStore*/ ctx[0].name_and_surname
			? /*$orderStore*/ ctx[0].name_and_surname
			: "") && input0.value !== input0_value_value) {
				prop_dev(input0, "value", input0_value_value);
			}

			if (dirty & /*$orderStore*/ 1 && input1_value_value !== (input1_value_value = /*$orderStore*/ ctx[0].email
			? /*$orderStore*/ ctx[0].email
			: "") && input1.value !== input1_value_value) {
				prop_dev(input1, "value", input1_value_value);
			}

			if (dirty & /*$orderStore*/ 1 && input2_value_value !== (input2_value_value = /*$orderStore*/ ctx[0].phone
			? /*$orderStore*/ ctx[0].phone
			: "") && input2.value !== input2_value_value) {
				prop_dev(input2, "value", input2_value_value);
			}

			if (dirty & /*$orderStore*/ 1 && input3_value_value !== (input3_value_value = /*$orderStore*/ ctx[0].address_stree
			? /*$orderStore*/ ctx[0].address_stree
			: "") && input3.value !== input3_value_value) {
				prop_dev(input3, "value", input3_value_value);
			}

			if (dirty & /*$orderStore*/ 1 && input4_value_value !== (input4_value_value = /*$orderStore*/ ctx[0].address_city
			? /*$orderStore*/ ctx[0].address_city
			: "") && input4.value !== input4_value_value) {
				prop_dev(input4, "value", input4_value_value);
			}

			if (dirty & /*$orderStore*/ 1 && input5_value_value !== (input5_value_value = /*$orderStore*/ ctx[0].address_zip
			? /*$orderStore*/ ctx[0].address_zip
			: "") && input5.value !== input5_value_value) {
				prop_dev(input5, "value", input5_value_value);
			}

			if (dirty & /*$orderStore*/ 1 && textarea_value_value !== (textarea_value_value = /*$orderStore*/ ctx[0].order_description
			? /*$orderStore*/ ctx[0].order_description
			: '')) {
				prop_dev(textarea, "value", textarea_value_value);
			}
		},
		i: noop,
		o: noop,
		d: function destroy(detaching) {
			if (detaching) detach_dev(p0);
			if (detaching) detach_dev(t2);
			if (detaching) detach_dev(p1);
			if (detaching) detach_dev(t5);
			if (detaching) detach_dev(p2);
			if (detaching) detach_dev(t8);
			if (detaching) detach_dev(p3);
			if (detaching) detach_dev(t11);
			if (detaching) detach_dev(p4);
			if (detaching) detach_dev(t14);
			if (detaching) detach_dev(p5);
			if (detaching) detach_dev(t17);
			if (detaching) detach_dev(p6);
			mounted = false;
			run_all(dispose);
		}
	};

	dispatch_dev("SvelteRegisterBlock", {
		block,
		id: create_fragment.name,
		type: "component",
		source: "",
		ctx
	});

	return block;
}

function instance($$self, $$props, $$invalidate) {
	let $orderStore;
	validate_store(orderStore, 'orderStore');
	component_subscribe($$self, orderStore, $$value => $$invalidate(0, $orderStore = $$value));
	let { $$slots: slots = {}, $$scope } = $$props;
	validate_slots('OrderPersonal', slots, []);

	const setValue = (name, value, inputElm) => {
		if (inputElm.checkValidity() && orderStore.setProp(name, value)) {
			inputElm.classList.remove('invalid');
		} else {
			inputElm.classList.add('invalid');
		}
	};

	const writable_props = [];

	Object.keys($$props).forEach(key => {
		if (!~writable_props.indexOf(key) && key.slice(0, 2) !== '$$' && key !== 'slot') console.warn(`<OrderPersonal> was created with unknown prop '${key}'`);
	});

	const blur_handler = e => setValue('name_and_surname', e.target.value, e.target);
	const blur_handler_1 = e => setValue('email', e.target.value, e.target);
	const blur_handler_2 = e => setValue('phone', e.target.value, e.target);
	const blur_handler_3 = e => setValue('address_street', e.target.value, e.target);
	const blur_handler_4 = e => setValue('address_city', e.target.value, e.target);
	const blur_handler_5 = e => setValue('address_zip', e.target.value, e.target);
	const blur_handler_6 = e => setValue('order_description', e.target.value, e.target);
	$$self.$capture_state = () => ({ orderStore, setValue, $orderStore });

	return [
		$orderStore,
		setValue,
		blur_handler,
		blur_handler_1,
		blur_handler_2,
		blur_handler_3,
		blur_handler_4,
		blur_handler_5,
		blur_handler_6
	];
}

class OrderPersonal extends SvelteComponentDev {
	constructor(options) {
		super(options);
		init(this, options, instance, create_fragment, safe_not_equal, {});

		dispatch_dev("SvelteRegisterComponent", {
			component: this,
			tagName: "OrderPersonal",
			options,
			id: create_fragment.name
		});
	}
}

export default OrderPersonal;